<script setup>
import { useMemberStore, useMetaStore } from '@/stores'
import _ from 'lodash-es'
import { useRouter } from 'vue-router'
const memStore=useMemberStore(),router=useRouter(),metaStore=useMetaStore()
if(memStore.isLoggedIn())router.push('/')
</script>
<template>
  <v-container class="bg-surface-light pa-0 ma-0 h-100" fluid>
    <v-row no-gutters class="h-100">
      <v-col cols="4">
        <v-row align-content="center" justify="center" class="h-100 bg-white ma-0">
          <v-col cols="12" class="text-center text-h2">
            <img style="max-width: 60%;" :src="metaStore.logo_fronturl"/>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="8">
        <v-row align-content="center" justify="center" class="h-100">
          <v-card class="mx-auto" width="500" elevation="10">
            <v-card-item>
              <v-card-title>
                <v-row class="w-100">
                  <v-col cols="11" class="font-weight-black">{{ $t(_.last($route.path.split('/'))) }}</v-col>
                  <v-col cols="1"><v-btn v-if="_.last($route.path.split('/'))=='signup'" variant="text" min-width="20px" @click="$router.push('/login')">
                    <v-icon icon="mdi-close"></v-icon>
                  </v-btn></v-col>
                </v-row>
              </v-card-title>
            </v-card-item>
            <v-card-text class="bg-surface-bright pt-4">
              <slot name="body"/>
            </v-card-text>
            <v-card-actions>
              <slot name="actions"/>
            </v-card-actions>
          </v-card>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
  <!--
    <locale-picker v-if="metaStore.dispmode!='minimum'" class="position-absolute" style="bottom: 10px;left: 10px;z-index: 9999;"/>
  -->
</template>
